export default __webpack_public_path__ + "static/media/UI-bg.c7efbf35.png";